import clsx from "clsx";
import { ToneMarker } from "../status/StatusBadge";
import type { Tone } from "../status/statusMap";
import { fmtNumber } from "../format";

export interface FilterChipItem { id: string; label: string; count?: number; tone?: Tone; disabled?: boolean }

/**
 * Attention filters with counts (§3): "Needs attention · 2". A tone adds the marker in that tone.
 * Rendered as a radio group; the selected chip is brand-tinted.
 */
export function FilterChips({ items, value, onChange, className, ariaLabel = "Filter" }: { items: FilterChipItem[]; value: string; onChange: (id: string) => void; className?: string; ariaLabel?: string }) {
  return (
    <div className={clsx("flex flex-wrap items-center gap-2", className)} role="radiogroup" aria-label={ariaLabel}>
      {items.map((it) => {
        const on = it.id === value;
        return (
          <button key={it.id} type="button" role="radio" aria-checked={on} disabled={it.disabled} onClick={() => onChange(it.id)}
            className={clsx("inline-flex h-8 items-center gap-2 whitespace-nowrap rounded-control border px-3 text-[13px] font-semibold transition-colors disabled:opacity-45",
              on ? "border-brand bg-brand-soft text-brand-text" : "border-line-strong bg-surface text-fg-2 hover:bg-surface-2")}>
            {it.tone && <span className={clsx("inline-flex", { ok: "text-ok", info: "text-info", warn: "text-warn", bad: "text-bad", neutral: "text-neutral" }[it.tone])}><ToneMarker tone={it.tone} /></span>}
            {it.label}{it.count !== undefined && <span className="font-medium"> · {fmtNumber(it.count)}</span>}
          </button>
        );
      })}
    </div>
  );
}
